import { render, staticRenderFns } from "./OrderUpdateControls.vue?vue&type=template&id=43675be0"
import script from "./OrderUpdateControls.vue?vue&type=script&lang=js"
export * from "./OrderUpdateControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports